import React from 'react';
import {
    BarChart as RechartsBarChart,
    XAxis,
    YAxis,
    Legend as RechartsLegend,
    Bar as RechartsBar,
    Cell,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';
import isFunction from 'lodash/fp/isFunction';

import { getFromDefaultColors, getColor } from './chartHelper';
import Legend from './Legend';

const BarChart = ({
    width = 480,
    height = 200,
    data = [],
    label = entry => entry.label,
    color,
    layout = 'vertical',
    legend = <Legend />,
    bars = [],
}) => {
    return (
        <ResponsiveContainer>
            <RechartsBarChart layout={layout} width={width} height={height} data={data}>
                {legend && (
                    <RechartsLegend
                        {...legend.props}
                        payload={data.map((entry, index) => {
                            const cellColor = getColor(entry.color) || getFromDefaultColors(entry, index);
                            return {
                                ...entry,
                                type: 'square',
                                color: isFunction(color) ? color(entry, index) : cellColor,
                                formatter: (value, entry) => <span className='text-color-darker'>{label(entry)}</span>,
                            };
                        })}
                    />
                )}
                <Tooltip />
                <XAxis type='number' height={14} />
                <YAxis type='category' dataKey={label} width={10} tickLine={false} axisLine={false} tickMargin={200} />
                {bars.map(bar => {
                    const { dataUnit } = bar.props;
                    return (
                        <RechartsBar
                            {...bar.props}
                            key={bar.key}
                            unit={dataUnit}
                            label={{
                                position: 'right',
                                formatter: value => `${value}${dataUnit}`,
                            }}
                        >
                            {data.map((entry, index) => {
                                const cellColor = getColor(entry.color) || getFromDefaultColors(entry, index);
                                return (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={isFunction(color) ? color(entry, index) : cellColor}
                                    />
                                );
                            })}
                        </RechartsBar>
                    );
                })}
            </RechartsBarChart>
        </ResponsiveContainer>
    );
};

export default BarChart;
